export default {
    'button.search': '搜索',
    'button.export': '导出'
};
